define('native/Api',['underscore'], function (_) {

    /* eslint-disable max-params */
    return function (
        LOG,
        session,
        gameLauncher,
        GameRunner,
        games,
        gameRoundDelay,
        navigation,
        referrerInfo,
        loginModel,
        touchIdSetupDialog
    )  {
    /* eslint-enable max-params */

        window.native = window.native || {};

        window.native.api = {

            closeGame: function () {
                // stop all game runners and flush and events queued by the gameRoundDelay
                gameLauncher.stopAllGameRunners();
                gameRoundDelay.endWait();
            },

            navigateTo: function (url) {
                // if the casumo app is active, try to navigate to a path to prevent full redirect
                // otherwise just navigate to the url
                var fragmentOrAbsoluteUrl = url;

                if (url.indexOf(window.location.origin) === 0) {
                    fragmentOrAbsoluteUrl = url.replace(window.location.origin, '');
                }

                navigation.navigateUrl(fragmentOrAbsoluteUrl);
            },

            markNotificationAsRead: function (id) {

                var notification = _.find(
                    session.player().notifications.pendingNotifications(),
                    'id',
                    id
                 );

                if (notification) {
                    notification.markAsRead();
                }
            },

            /**
             * If the webview reloads due to crash/3rd party navigation it loses
             * reference to any open games, and the winDelay is then lost.
             * If a refresh occurs the native layer will inform the app if any game is
             * running to reinstate it as an active game runner
             * @param gameSlug
             * @param providerType
             * @param isPractice
             */
            registerOpenGameInGameRunner: function (gameSlug, providerType, isPractice) {

                // here we need to load the game and then create a game runner for it
                var game = games.getGameBySlug(gameSlug);

                game.load().then(function () {

                    var gameRunner = new GameRunner(game, null, isPractice);

                    gameRunner.model(gameRunner.createGameModel(providerType));

                    // Register new gameRunner with the gameLauncher
                    gameLauncher.activeGameRunners([gameRunner]);
                }).catch(function (err) {
                    LOG.error('game failed to load', err);
                });
            },

            /**
             * Update referrer info.  Native attribution happens asynchronously,
             * so update the cookie data with correct
             * values after the handshake is complete.
             * @deprecated - Legacy for old apps, use setAllAttributionData
             * @param btag
             * @param sourceId
             */
            setAttributionData: function (btag, sourceId) {

                referrerInfo.referrer('netrefer');
                referrerInfo.metadata.affId(btag.substr(0, 6));
                referrerInfo.metadata.bannerId(btag);
                referrerInfo.metadata.marketingSourceId(sourceId);

            },

            login: function (username, password) {
                var loginCommand;

                loginModel.user(username);
                loginModel.plainTextPassword(password);
                loginCommand = loginModel.createCommand(function () {
                    navigation.navigate(navigation.ROUTES.PLAYER);
                });
                loginCommand.dispatch();
            },

            /**
             * Update referrer info.  Native attribution happens asynchronously,
             * so update the cookie data with correct
             * values after the handshake is complete.
             * @param dataString
             */
            setAllAttributionData: function (dataString) {
                var data;

                // here we get all the Native attribution data as a json string,
                // so parse and update the cookie
                try {
                    data = JSON.parse(dataString);

                    // handle affiliates
                    if (data.btag) {
                        referrerInfo.referrer('netrefer');
                        referrerInfo.metadata.affId(data.btag.substr(0, 6));
                        referrerInfo.metadata.bannerId(data.btag);
                        referrerInfo.metadata.marketingSourceId(data.media_source);
                    }

                }  catch (err) {
                    LOG.error('could not parse native attribution data', err);
                }
            },

            touchIdSetupResult: touchIdSetupDialog.touchIdResultReceived
        };
    };

});


